import { TranslateService } from '@ngx-translate/core';
import { Injectable } from "@angular/core";

@Injectable()
export class ActivityService {
    test: boolean = false;

    constructor(private translate: TranslateService) { }

    getDomain() {
        return this.test ? "http://localhost:8080" : "https://spooorts.de/trackerimport";
    }

    requestStravaAccessData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/strava/access/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestPolarAccessData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/polar/access/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestGarminAccessData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/garmin/access/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestFitbitAccessData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/fitbit/access/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestStravaActivityData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/strava/activities/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestPolarActivityData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/polar/activities/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestGarminActivityData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/garmin/activities/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestFitbitActivityData(lid: number) {
        return new Promise((resolve, reject) => {
            fetch(this.getDomain() + "/web/request/fitbit/activities/" + lid)
                .then((res) => res.text())
                .then((res) => {
                    console.log(res);
                    return res;
                })
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(response => resolve(response))
                .catch(err => {
                    console.error(err);
                    reject();
                })
        });
    }

    requestStravaAuthorization(lid: number) {
        return fetch(this.getDomain() + "/web/authorization/strava/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    requestPolarAuthorization(lid: number) {
        return fetch(this.getDomain() + "/web/authorization/polar/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    requestGarminAuthorization(lid: number) {
        return fetch(this.getDomain() + "/web/authorization/garmin/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    requestFitbitAuthorization(lid: number) {
        return fetch(this.getDomain() + "/web/authorization/fitbit/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    disconnectStrava(lid: number) {
        return fetch(this.getDomain() + "/web/unauthorization/strava/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    disconnectPolar(lid: number) {
        return fetch(this.getDomain() + "/web/unauthorization/polar/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    disconnectGarmin(lid: number) {
        return fetch(this.getDomain() + "/web/unauthorization/garmin/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    disconnectFitbit(lid: number) {
        return fetch(this.getDomain() + "/web/unauthorization/fitbit/" + lid)
            .then(response => response.text())
            .then(url => url);
    }

    createYearlyChartData(endurances: any, targetYear: any): ChartData {
        let chartData = {
            labels: MONTH.map(m => this.translate.instant(m)),
            datasets: []
        };

        for (let i = 0; i < endurances.length; i++) {
            let trainingIndex = endurances[i].trainings.findIndex(x => x.year == targetYear);
            let x = [];
            for (let j = 0; j < 12; j++) {
                let monthIndex;
                if (trainingIndex >= 0) {
                    monthIndex = endurances[i].trainings[trainingIndex].yearStats.findIndex(x => x.monthNo == (j + 1));
                }
                x.push(monthIndex >= 0 ? endurances[i].trainings[trainingIndex].yearStats[monthIndex].distMeterSum / 1000 : 0);
            }
            chartData.datasets.push(this.getChartLineConfig(endurances[i].name, COLORS[i], x));
        }
        return chartData;
    }

    createAllYearsChartData(endurances: any): ChartData {
        if (!endurances || !endurances.length) return;

        let chartData = {
            labels: endurances[0].trainings.map(m => m.year),
            datasets: []
        };
        for (let i = 0; i < endurances.length; i++) {
            let x = [];
            for (let j = 0; j < endurances[i].trainings.length; j++) {
                // x.push(Math.floor(endurances[i].trainings[j].yearStats.reduce((acc, cum) => acc + cum.distMeterSum, 0) / 1000));
                x.push((endurances[i].trainings[j].yearStats.reduce((acc, cum) => acc + cum.distMeterSum, 0) / 1000));
            }
            console.log('x: ', x);
            chartData.datasets.push(this.getChartLineConfig(endurances[i].name, COLORS[i], x));
        }
        return chartData;
    }

    private getChartLineConfig(label: string, color: string, x: any) {
        return {
            label: label,
            lineTension: 0.1,
            backgroundColor: "transparent", //nothing changes
            borderColor: color,
            borderCapStyle: 'round',
            borderDash: [],
            borderDashOffset: 2.0,
            borderJoinStyle: 'miter',
            pointBorderColor: color,
            pointBackgroundColor: "#fff",
            pointBorderWidth: 3,
            stepped: false,
            pointHoverRadius: 4,
            pointRadius: 4,
            pointHitRadius: 4,
            data: x
        };
    }
}


export enum PARTNER_PROVIDERS {
    STRAVA,
    POLAR,
    GARMIN,
    FITBIT,
    NIKE,
    ADIDAS,
}
export interface ChartData {
    labels: any[];
    datasets: any[];
}
export const MONTH = ['JAN_MONTH', 'FEM_MONTH', 'MAR_MONTH', 'APR_MONTH', 'MAY_MONTH', 'JUN_MONTH', 'JUL_MONTH', 'AUG_MONTH', 'SEP_MONTH', 'OCT_MONTH', 'NOV_MONTH', 'DEC_MONTH'];
export const COLORS = [
    "red",
    "green",
    "black",
    "yellow",
    "pink",
    "orange",
    "grey",
    "blue",
    "lime",
    "maroon",
    "navy",
    "olive",
    "purple"
];


// WEBPACK FOOTER //
// /src/providers/activities.service.ts